var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-radio-group', { staticClass: "partner-info", model: { value: _vm.val, callback: function callback($$v) {
        _vm.val = $$v;
      }, expression: "val" } }, _vm._l(_vm.list, function (partner) {
    return _c('el-radio', { key: partner.partner_code, attrs: { "label": partner.partner_code, "disabled": !_vm.isApprovedPartner(partner) } }, [_vm._v("\n    " + _vm._s(partner.name) + "\n    "), partner.country_code ? [_vm._v("\n      -\n      "), _c('icon-language', { attrs: { "code": partner.country_code, "name": _vm.getCountryName(partner.country_code, _vm.countries) } })] : _vm._e()], 2);
  }), 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };